import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// TODO: this should come from the org API
// Sequence: VIN, Whole Vehicle, Reg, Odometer, Damage
// Assumption assetImageTypes order don't change
const photoSequence = [0, 2, 1, 3, 4];

export default (imgIndex, imageTypes) => {
    const { assetDetails } = useSelector((state) => state);
    const { photos } = assetDetails;

    // Check that imageTypeId can be mapped with available imageTypes
    const imageTypeIndex =
        photoSequence[imgIndex] !== undefined &&
        imageTypes[photoSequence[imgIndex]] !== undefined
            ? photoSequence[imgIndex]
            : imageTypes.length - 1;

    const [imageTypeId, setImageTypeId] = useState(
        imageTypes[imageTypeIndex].id
    );

    useEffect(() => {
        // once image is set do not allow to change imageType on index change
        // only via modal type selection
        let typeId =
            !photos[imgIndex] || !Object.keys(photos[imgIndex]).length
                ? imageTypes[imageTypeIndex].id
                : photos[imgIndex].imageType;

        setImageTypeId(typeId);
    }, [imageTypeIndex, imgIndex]);

    return [imageTypeId, setImageTypeId];
};
